var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.el && (_vm.el.scrollHeight-_vm.rect.height))?_c('section',{staticClass:"up-down"},[_c('i',{staticClass:"el-icon-caret-top",attrs:{"size":"32"},on:{"click":_vm.up}}),_vm._v(" "),_c('i',{staticClass:"el-icon-caret-bottom",attrs:{"size":"32"},on:{"click":_vm.down}})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aaf3da1","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/zzcbpmDashboard/common/upDown.vue
// module id = null
// module chunks = 